import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-009d66f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { useGameStateStore } from "@/store/gameState";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { GameState } from "@/store/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'Log',
  setup(__props) {

const logClassName = "log";

const state = useGameStateStore();

const { gameState, pickedDoor, doorsState, win } = storeToRefs(state);

const logs = computed(() => {
  const result = [];

  switch (gameState.value) {
    case GameState.pick: {
      result.push("Choose a prize door.");

      break;
    }
    case GameState.reveal: {
      let anotherDoor = 0;

      doorsState.value.forEach((item, index) => {
        if (index !== pickedDoor.value && !doorsState.value[index]) {
          anotherDoor = index;
        }
      });
      result.push(`You picked the door No. ${(pickedDoor.value || 0) + 1}.`);
      result.push(`Do you want to pick the door No. ${anotherDoor + 1}?`);

      break;
    }
    case GameState.gameOver: {
      result.push(win.value ? "You Win! Try again." : "You Loose! Try again.");

      break;
    }
  }

  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(logClassName)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logs), (log, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        innerHTML: log
      }, null, 8, _hoisted_1))
    }), 128))
  ]))
}
}

})